var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "h4",
        [
          _c("b-icon", { attrs: { icon: "check-all" } }),
          _vm._v("Aprobaciones")
        ],
        1
      ),
      !_vm.approvals
        ? _c(
            "div",
            [
              _c("b-icon", {
                staticClass: "orange",
                attrs: { icon: "info-circle" }
              }),
              _vm._v("Este documento no ha pasado por un flujo de aprobación. ")
            ],
            1
          )
        : _vm._e(),
      _vm._l(_vm.approvals, function(approver, index) {
        return _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.approvals && _vm.approvals.length > 0,
                expression: "approvals && approvals.length > 0"
              }
            ],
            key: index,
            staticClass: "aprobaciones"
          },
          [
            _c("div", { staticClass: "numero" }, [_vm._v(_vm._s(index + 1))]),
            _c("div", { staticClass: "nombre" }, [
              approver.personas && approver.personas.length > 0
                ? _c("span", [_vm._v("Grupo:")])
                : _vm._e(),
              _vm._v(" " + _vm._s(approver.nombre) + " "),
              _c(
                "div",
                { staticClass: "d-flex align-items-center" },
                [
                  _c("ApprovalsIcons", { attrs: { item: approver } }),
                  _c("span", { staticClass: "ml-2 accion-aprobador" }, [
                    _vm._v(_vm._s(approver.accion))
                  ])
                ],
                1
              )
            ]),
            _c("div", { staticClass: "correo" }, [
              _vm._v(_vm._s(approver.correo))
            ]),
            approver.personas
              ? _c(
                  "div",
                  _vm._l(approver.personas, function(person, index) {
                    return _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value:
                              person.accion === "Aprobado" ||
                              person.accion === "Rechazado",
                            expression:
                              "person.accion === 'Aprobado' || person.accion === 'Rechazado'"
                          }
                        ],
                        key: index,
                        staticClass: "persona",
                        attrs: { title: person.fecha }
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "content" },
                          [_c("ApprovalsIcons", { attrs: { item: person } })],
                          1
                        ),
                        _c("div", { staticClass: "d-inline-block" }, [
                          _vm._v(_vm._s(person.nombre))
                        ]),
                        _c("div", { staticClass: "correo-persona" }, [
                          _vm._v(_vm._s(person.correo))
                        ])
                      ]
                    )
                  }),
                  0
                )
              : _vm._e(),
            approver.fecha
              ? _c("div", { staticClass: "fecha" }, [
                  _vm._v(
                    " " +
                      _vm._s(approver.fecha.replace(" ", " a las ")) +
                      " hrs. "
                  )
                ])
              : _vm._e(),
            _c("div", { staticClass: "clear" })
          ]
        )
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }